import { EntityViewKanban } from '@jms/model';
import { SettingsPanelOptionId } from '@workbuddy/ui/v2/blocks/settings.panel';
import { KanbanValueSetOption } from '../../../model/kanban.value.set';
import { toColumnSelection } from './resolve.kanban.column.values';

/**
 * What the Columns picker should be ticking, given the field on screen and the view that was saved.
 *
 * This is a seeding decision rather than a straight derivation because the two inputs disagree at two
 * moments the editor has to survive. The value set loads per field and asynchronously, so between the
 * Column dropdown changing and the new set arriving the saved columns describe a field that is no
 * longer chosen. And a saved view's `columns` are ids and rules over ONE field's value set: carried
 * onto a different field they tick nothing and, worse, get written back as that field's configuration.
 *
 * So the saved columns are honoured only while the chosen field is still the one they were saved
 * against; every other field seeds from its own value set, which is the all-ticked default.
 */
export interface KanbanColumnSeed {
  /** The picker selection to write into the form. */
  selection: SettingsPanelOptionId[];
  /** False while the value set for the chosen field has not arrived, so the form must not be rewritten. */
  resolved: boolean;
}

export function resolveKanbanColumnSeed(chosenPath: string | null, saved: Partial<EntityViewKanban> | null | undefined, valueSet: KanbanValueSetOption[] | null | undefined, group: { path: string; label: string } | null): KanbanColumnSeed {

  const savedPath = saved?.column ? String(saved.column) : null;
  const columns = chosenPath && chosenPath === savedPath ? saved?.columns : undefined;

  return {
    selection: toColumnSelection(columns, valueSet, group),
    resolved: !!valueSet?.length,
  };
}
